import { Injectable } from '@angular/core';

import { UserPermission } from '../models/user-permission';
import { JsonHttpService } from '../../shared/http/json-http.service';

@Injectable({
    providedIn: 'root'
})
export class UserPermissionService {

    constructor(private httpService: JsonHttpService) { }

    getUserPermissions(): Promise<UserPermission[]> {
        return this.httpService.get('/api/users/permissions/get-permissions').toPromise();
    }
}
